module.exports = __webpack_public_path__ + "img/auth-background.fbc1a4b9.png";